import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=66b850ac&scoped=true&"
import script from "./BaseInput.js?vue&type=script&lang=js&"
export * from "./BaseInput.js?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=66b850ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b850ac",
  null
  
)

export default component.exports